export default __webpack_public_path__ + "static/media/Just for Laughs - Logo2.f2990334.png";